var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout_containner_item",style:({ height: _vm.height })},[_vm._t("default"),_c('div',{staticClass:"layout_containner_item_b"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }